export default "__VITE_ASSET__BoV9UM8M__"